import { ITableColumn } from "components/interfaces";
import { computed, makeObservable } from "mobx";
import { lang } from "../i18nLang";
import { formatCode } from "../utils";
import { DiscountStore, MeasurementListStore } from "./";

class Store {
  public readonly blankColumns: number = 5;
  public readonly columns: ITableColumn[] = [
    {
      dataKey: "code",
      label: lang("fields.code"),
      align: "right",
      width: 120,
    },
    {
      dataKey: "title",
      label: lang("fields.title"),
    },
    {
      dataKey: "description",
      label: lang("fields.description"),
    },
    {
      dataKey: "type",
      label: lang("fields.type"),
      width: 150,
    },
    {
      dataKey: "date",
      label: lang("fields.createdDate"),
      width: 150,
    },
    /* Os valores fixos sao necessarios para manter a tabela alinhada */
    {
      dataKey: "total",
      label: lang("fields.value"),
      width: 150,
      monetary: true,
      align: "right",
    },
    {
      dataKey: "installment",
      label: lang("fields.installment"),
      width: 150,
    },
    {
      dataKey: "maturity",
      label: lang("fields.maturity"),
      width: 150,
    },
    {
      dataKey: "link",
      label: lang("discounts.fields.link"),
      width: 150,
    },
  ];
  public readonly subColumns: ITableColumn[] = [
    /* Os valores fixos sao necessarios para manter a tabela alinhada */
    {
      dataKey: "value",
      label: "",
      width: 150,
      monetary: true,
      align: "right",
    },
    {
      dataKey: "parcel",
      label: "",
      width: 150,
    },
    {
      dataKey: "maturityDate",
      label: "",
      width: 150,
    },
    {
      dataKey: "measurementLink",
      label: "",
      width: 300,
    },
  ];

  constructor() {
    makeObservable(this, {
      rows: computed,
    });
  }

  get rows() {
    const formatInstallments = (installments) =>
      installments.map((installment) => {
        return {
          ...installment,
          parcel: `${installment.id}/${installments.length} parcela`,
          maturityDate: installment.maturityDate.toLocaleDateString("pt-br"),
          measurementName: MeasurementListStore.getMeasurementName(
            installment.measurementId
          ),
        };
      });

    return DiscountStore.discounts.map((discount) => ({
      id: discount.uid,
      code: formatCode(discount.code),
      title: discount.title,
      date: discount.getDate()?.toLocaleDateString("pt-br"),
      description: discount.description,
      type: lang(`discounts.types.${discount.type}`),
      total: discount.total,
      installments: formatInstallments(discount.installments),
    }));
  }
}

const DiscountTableStore = new Store();
export default DiscountTableStore;
